import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CheckboxProps } from './Checkbox.props';
import {
  CheckboxSelectionCheckedIcon,
  CheckboxSelectionIcon,
  CheckboxSelectionIndeterminateIcon,
  StyledCheckboxLabel,
  StyledCheckboxRoot,
} from './Checkbox.styles';

const selectionIcon = <CheckboxSelectionIcon data-checkbox-selection-icon />;
const selectionCheckedIcon = <CheckboxSelectionCheckedIcon data-checkbox-selection-icon />;
const selectionIndeterminateIcon = <CheckboxSelectionIndeterminateIcon data-checkbox-selection-icon />;

const Checkbox = ({
  checked,
  checkedIcon,
  disableRipple,
  error = false,
  helperText,
  icon,
  indeterminateIcon,
  label,
  onChange,
  visualVariant = 'default',
  ...props
}: CheckboxProps) => {
  const isSelectionVariant = visualVariant === 'selection';
  const control = (
    <StyledCheckboxRoot
      checked={checked}
      checkedIcon={isSelectionVariant ? checkedIcon ?? selectionCheckedIcon : checkedIcon}
      disableRipple={isSelectionVariant ? disableRipple ?? true : disableRipple}
      icon={isSelectionVariant ? icon ?? selectionIcon : icon}
      indeterminateIcon={isSelectionVariant ? indeterminateIcon ?? selectionIndeterminateIcon : indeterminateIcon}
      onChange={event => onChange?.(event.target.checked)}
      visualVariant={visualVariant}
      {...props}
    />
  );

  if (!label) {
    return control;
  }

  return (
    <Stack spacing={0.5}>
      <StyledCheckboxLabel
        hasError={error}
        control={control}
        label={label}
      />
      {helperText ? (
        <Typography color={error ? 'error.main' : 'text.secondary'} variant="caption">
          {helperText}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default Checkbox;
